<template>
  <span v-if="params.roles">
    <div>
      <select v-model="selection" v-if="params.data.learnerBuildingLEA && !params.locked()" class="mt-1 p-1 rounded-1 w-100">
        <option value=''>(Select)</option>
        <option :class="optionClass(c.value)" v-for="c in params.roles.value" :key="c.value" :value="c.value">{{ c.text }}</option>
      </select>
      <span v-else-if="!params.data.learnerBuildingLEA" class="badge bg-warning">Select LEA First</span>
      <span v-else-if="params.locked()">(Not Assigned)</span>
    </div>
  </span>
</template>

<style scoped>
  .default-role {
    font-weight: bold;
  }
</style>

<script lang="js">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
      selection: '',
      defaultChoices: []
      // ,
      // roles: []
    }
  },
  beforeMount() {
    // this.roles = this.params.roles
    this.selection = this.params.data.learnerRoleType || ''
    this.defaultChoices = [...new Set(this.params.data.roleSelectionMetadataItems.filter(c=>c.schoolLEA === this.params.data.learnerBuildingLEA).map(s=>{ return { roleTypeId: s.roleTypeId, jobFunction: s.jobFunction, rubricVersionId: s.rubricVersionId }}))]
  },
  computed: {
    choiceInfo() {
      return {
        leas: new Set(this.params.data.roleSelectionMetadataItems.map(r=>r.schoolLEA)).size,
        roles: new Set(this.params.data.roleSelectionMetadataItems.map(r=>r.roleTypeId)).size
      }
    }
  },
  methods: {
    applyChoice: function(choiceRoleType) {
      if (this.params.data.learnerRoleType != choiceRoleType) {
        this.params.data.learnerRoleType = choiceRoleType
        this.params.updateCallback(this.params.data)
      }
    },
    optionClass(roleTypeId) {
      const rolesAtLEA = [...new Set(this.params.data.roleSelectionMetadataItems.filter(c=>c.schoolLEA === this.params.data.learnerBuildingLEA))]
      return rolesAtLEA.filter(r => r.roleTypeId == roleTypeId).length > 0 ? 'default-role' : ''
    }
  },
  watch: {
    'params.data.learnerBuildingLEA': function (newLEA) {
      //console.log(`Building changed to ${newLEA}`);
      if (newLEA) {
        this.defaultChoices = [...new Set(this.params.data.roleSelectionMetadataItems.filter(c=>c.schoolLEA === newLEA).map(s=>{ return { roleTypeId: s.roleTypeId, jobFunction: s.jobFunction, rubricVersionId: s.rubricVersionId }}))]
        if (this.defaultChoices.length == 1) {
          this.selection = this.defaultChoices[0].roleTypeId
        }
      }
    },
    selection() {
      const selectedRole = this.params.roles.value.find(c => c.value == this.selection)
      this.applyChoice(selectedRole?.value)
    }
  }
})

</script>